import Backbone = require("backbone");
import Model = require("../models/base-model");
import deepExtend = require("../utils/deep-extend");

interface Foo<T> {
    on(eventName: string, callback: Function): void;
    on(eventName: 'add', callback: (model: Model<T>) => void): void;
}

class Collection<T extends { id?: string }> extends Backbone.Collection<Model<T>> implements Foo<T> {

    ModelClass: Model<T>;

    static about = `
Base collections provide merge, updateModel and onAdd helpers to simplify management.
    `;

    constructor() {
        super(null, {model: Model});
    }

    merge(item: T, options = null) {
        // if not id then it is impossible to resolve duuplicates (e.g. a duplicate google geoquery result)
        if (typeof item.id === "undefined") throw "must have an id";
        let model = this.get(item.id); // TODO: possible to use model.idAttribute?
        if (!model) {
            model = new this.model(item, options);
            super.add(model);
        } else {
            this.updateModel(model, item);
        }
        return model;
    }

    updateModel(model: Model<T>, item: T) {
        deepExtend(model.data, item);
        model.set("_rev", (model.get("_rev") || 0) + 1);
    }

    onAdd(cb: (model: Model<T>, collection: Collection<T>, action: { add: boolean }) => void) {
        let h = this.on("add", cb);
        return () => this.off("add", cb);
    }

}

export = Collection;